

















































































import { Component, Watch, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { navBarType } from '@/types/navBar.type'
import {
  alertStore,
  appStore,
  authUserStore,
  dataStore,
  icTagStore,
  modalErrorStore
} from '@/store'
import {
  AUTH_LOGOUT,
  PAGE_USER_RESET,
  PAGE_REFERENCE_RESET,
  PAGE_LEND_STORE_RESET,
  NAV_LOADING_START,
  NAV_LOADING_END,
  PAGE_LOADING_START,
  PAGE_LOADING_END,
  LEND_LIST_TAB_RESET,
  PAGE_BIBLIOGRAPHIES_RESET,
  PAGE_RETURN_INPUT_COLLECTION_ID_FOCUS
} from '@/config/event'
import { AlertFactory } from '@/factory'
import { Alert, AlertMessage, AuthUserGroup, ErrorMessage } from '@/api'
import { AlertCodeALC00002, AlertCodeCLT00009 } from '@/types'
import ModalUsageStatistics from '@/components/modals/ModalUsageStatistics/ModalUsageStatistics.vue'
import { ModalVersionInfo } from '@/components/modals/ModalVersionInfo'

interface UserMenuItem {
  text: string
  action: string
}

@Component({
  components: {
    ModalUsageStatistics,
    ModalVersionInfo
  }
})
export default class TheNavBar extends ComponentVue {
  @Ref()
  modalUsageStatistics!: ModalUsageStatistics

  @Ref()
  modalVersionInfo!: ModalVersionInfo

  activeColor: string = 'green'

  avatar: string = require('~/assets/images/avatar.png')

  menus: navBarType.INavBarItem[] = [
    {
      text: 'トップ',
      path: navBarType.NavBar.Top,
      functionKey: 'F12',
      icon: 'mdi-home'
    },
    {
      text: '貸出',
      path: navBarType.NavBar.Lend,
      functionKey: 'F1',
      icon: 'mdi-book-open'
    },
    {
      text: '返却',
      path: navBarType.NavBar.Return,
      functionKey: 'F2',
      icon: 'mdi-package-up'
      // icon: 'mdi-arrow-up-bold-box'
    },
    {
      text: '資料の管理',
      path: navBarType.NavBar.Bibliographies,
      functionKey: 'F3',
      icon: 'mdi-book-open-variant'
    },
    {
      text: '利用者の管理',
      path: navBarType.NavBar.User,
      functionKey: 'F4',
      icon: 'mdi-account'
    },
    {
      text: 'レファレンス',
      path: navBarType.NavBar.Reference,
      functionKey: 'F6',
      icon: 'mdi-magnify-plus'
    }
  ]

  userMenuItems: UserMenuItem[] = [
    {
      text: '処理場所の変更',
      action: 'change-place'
    },
    {
      text: '印刷履歴',
      action: 'print-history'
    },
    {
      text: '画面印刷',
      action: 'screenshot'
    },
    {
      text: 'バージョン情報',
      action: 'version-info'
    },
    {
      text: 'ログアウト',
      action: 'logout'
    }
  ]

  loading: boolean = false

  get cssCustomProperty(): any {
    return {
      'background-color': dataStore.headerBarColor
    }
  }

  get activeNavBar(): string {
    return appStore._activeNavBar
  }

  get fontSize(): number {
    return appStore._fontSizeNormal
  }

  get fontSizeType(): string {
    return appStore._fontSizeType
  }

  get styles(): object {
    if (this.fontSizeType === 'normal') {
      return {}
    }

    return {
      'font-size': this.fontSize + 'px'
    }
  }

  get isActiveNav() {
    return (menu: navBarType.INavBarItem) => {
      if (this.activeNavBar === '/') {
        return menu.path === '/'
      }

      return menu.path.startsWith(this.activeNavBar)
    }
  }

  get routeIsLend(): boolean {
    return this.$route.fullPath.match(/^\/lend$|^\/lend\//) !== null
  }

  get routeIsReturn(): boolean {
    return this.$route.fullPath.match(/^\/return$|^\/return\//) !== null
  }

  get routeIsBibliographies(): boolean {
    return (
      this.$route.fullPath.match(/^\/bibliographies$|^\/bibliographies\//) !==
      null
    )
  }

  get routeIsUser(): boolean {
    return this.$route.fullPath.match(/^\/user$|^\/user\//) !== null
  }

  get routeIsReference(): boolean {
    return this.$route.fullPath.match(/^\/reference$|^\/reference\//) !== null
  }

  get authUserGroup(): AuthUserGroup {
    return authUserStore.authUserGroup
  }

  get displayMenus(): navBarType.INavBarItem[] {
    return this.menus.filter((menu: navBarType.INavBarItem, index) => {
      return (
        index === 0 ||
        (index === 1 && this.authUserGroup.lending !== 0) ||
        (index === 2 && this.authUserGroup.return !== 0) ||
        (index === 3 && this.authUserGroup.bibliography !== 0) ||
        (index === 4 && this.authUserGroup.user !== 0) ||
        (index === 5 && this.authUserGroup.reference !== 0)
      )
    })
  }

  @Watch('$route', { immediate: true })
  onRouteChanged() {
    this.setNavigationValue()

    if (this.routeIsLend) {
      const newMenu = Object.assign({}, this.menus[1], {
        path: this.$route.path
      })
      this.menus.splice(1, 1, newMenu)
    } else if (this.routeIsBibliographies) {
      const newMenu = Object.assign({}, this.menus[3], {
        path: this.$route.fullPath
      })
      this.menus.splice(3, 1, newMenu)
    } else if (this.routeIsUser) {
      let path: string = ''

      if (this.$route.query?.page === 'edit') {
        path = this.$route.path

        Object.entries(this.$route.query).forEach(([key, value]) => {
          if ((key === 'page' && value === 'edit') || value === undefined) {
            return
          }

          path += path === this.$route.path ? '?' : '&'
          path += `${key}=${value}`
        })
      } else if (this.$route.fullPath === '/user/create') {
        path = navBarType.NavBar.User
      } else {
        path = this.$route.fullPath
      }

      const newMenu = Object.assign({}, this.menus[4], {
        path
      })

      this.menus.splice(4, 1, newMenu)
    } else if (this.routeIsReference) {
      const newMenu = Object.assign({}, this.menus[5], {
        path:
          this.$route.fullPath === '/reference/create'
            ? navBarType.NavBar.Reference
            : this.$route.path
      })
      this.menus.splice(5, 1, newMenu)
    }
  }

  mounted() {
    addEventListener('keydown', this.onKeydown)
    this.$eventBus.on(NAV_LOADING_START, this.onNavLoadingStart)
    this.$eventBus.on(NAV_LOADING_END, this.onNaviLoadingEnd)
  }

  beforeDestroy() {
    removeEventListener('keydown', this.onKeydown)
    this.$eventBus.off(NAV_LOADING_START)
    this.$eventBus.off(NAV_LOADING_END)
  }

  clearKeyDefaultAction(event: KeyboardEvent): void {
    if (
      event.key === 'F1' ||
      event.key === 'F2' ||
      event.key === 'F3' ||
      event.key === 'F4' ||
      event.key === 'F5' ||
      event.key === 'F6' ||
      event.key === 'F7' ||
      event.key === 'F8' ||
      event.key === 'F9' ||
      event.key === 'F10' ||
      event.key === 'F11' ||
      event.key === 'F12'
    ) {
      event.returnValue = false
    }
  }

  settingKeydown(event: KeyboardEvent): void {
    if (icTagStore.processing) {
      return
    }

    switch (event.key) {
      case 'F1':
        if (this.authUserGroup.lending !== 0) {
          this.go(this.menus[1].path)
        }
        break
      case 'F2':
        if (this.authUserGroup.return !== 0) {
          this.go(this.menus[2].path)
        }
        break
      case 'F3':
        if (this.authUserGroup.bibliography !== 0) {
          this.go(this.menus[3].path)
        }
        break
      case 'F4':
        if (this.authUserGroup.user !== 0) {
          this.go(this.menus[4].path)
        }
        break
      case 'F6':
        if (this.authUserGroup.reference !== 0) {
          this.go(this.menus[5].path)
        }
        break
      case 'F12':
        this.go(this.menus[0].path)
        break
      case 'q':
        if (event.ctrlKey) {
          this.$modalQuickMenu.open()
        }
        break
      case 'Escape':
        this.$modalQuickMenu.close()
    }
  }

  onKeydown(event: KeyboardEvent): void {
    this.clearKeyDefaultAction(event)
    this.settingKeydown(event)

    // console.log('@@@ clearFunctionKeyDefaultAction', event)
  }

  onNavLoadingStart() {
    this.loading = true
  }

  onNaviLoadingEnd() {
    this.loading = false
  }

  setNavigationValue(): void {
    let path: navBarType.NavBar
    if (this.$route.path) {
      path = navBarType.getNavBar('/' + this.$route.path.split('/')[1])
    } else {
      path = navBarType.NavBar.Top
    }
    appStore.setActiveNavBar(path)
  }

  go(nextLocation: string) {
    this.debug('go', nextLocation)
    if (this.routeIsLend) {
      if (this.routeIsLendToLend(nextLocation)) {
        this.$eventBus.emit(LEND_LIST_TAB_RESET)
        this.$eventBus.emit(PAGE_LEND_STORE_RESET)
        return
      }

      this.$router.push(nextLocation)
    } else if (this.routeIsReturnToReturn(nextLocation)) {
      this.$eventBus.emit(PAGE_RETURN_INPUT_COLLECTION_ID_FOCUS)
    } else if (this.routeIsBibliographiesToBibliographies(nextLocation)) {
      const alert: Alert = AlertFactory.create(AlertCodeCLT00009)

      alertStore.setItem(alert)
      this.$modalAlert.open({
        onOkClick: () => {
          this.menus[3].path = navBarType.NavBar.Bibliographies
          this.$router.push(navBarType.NavBar.Bibliographies)

          // 遷移してからリセットをかけることで各ページのwatchを発動させないようにしている
          this.$nextTick(() => {
            setTimeout(() => {
              this.$eventBus.emit(PAGE_BIBLIOGRAPHIES_RESET)
            })
          })
        }
      })
    } else if (this.routeIsUserToUser(nextLocation)) {
      const alert: Alert = AlertFactory.create(AlertCodeCLT00009)

      alertStore.setItem(alert)
      this.$modalAlert.open({
        onOkClick: () => {
          this.$eventBus.emit(PAGE_USER_RESET)
          this.menus[4].path = navBarType.NavBar.User
          this.$router.push(navBarType.NavBar.User)
        }
      })
    } else if (this.routeIsReferenceToReference(nextLocation)) {
      const alert: Alert = AlertFactory.create(AlertCodeCLT00009)

      alertStore.setItem(alert)
      this.$modalAlert.open({
        onOkClick: () => {
          this.$eventBus.emit(PAGE_REFERENCE_RESET)
          this.menus[5].path = navBarType.NavBar.Reference
          this.$router.push(navBarType.NavBar.Reference)
        }
      })
    } else if (appStore.isEditing) {
      const alert: Alert = AlertFactory.create(AlertCodeALC00002)
      alertStore.setItem(alert)
      this.$modalAlert.open({
        onOkClick: () => {
          appStore.setIsEditing(false)
          this.$router.push(nextLocation)
        }
      })
    } else {
      this.$router.push(nextLocation)
    }
  }

  routeIsLendToLend(nextLocation: string): boolean {
    return nextLocation.startsWith('/lend') && this.routeIsLend
  }

  routeIsReturnToReturn(nextLocation: string): boolean {
    return nextLocation.startsWith('/return') && this.routeIsReturn
  }

  routeIsBibliographiesToBibliographies(nextLocation: string): boolean {
    return (
      nextLocation.startsWith('/bibliographies') && this.routeIsBibliographies
    )
  }

  routeIsUserToUser(nextLocation: string): boolean {
    return nextLocation.startsWith('/user') && this.routeIsUser
  }

  routeIsReferenceToReference(nextLocation: string): boolean {
    return nextLocation.startsWith('/reference') && this.routeIsReference
  }

  async logout() {
    this.$eventBus.emit(PAGE_LOADING_START)
    this.$eventBus.emit(AUTH_LOGOUT)

    try {
      await authUserStore.logout()

      await this.$router.push('/login')
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  onUserMenuClick(userMenuItem: UserMenuItem) {
    this.debug('onUserMenuClick() userMenuItem=', userMenuItem)
    switch (userMenuItem.action) {
      case 'change-place':
        this.$modalProcessPlaceChange.open()
        break
      case 'print-history':
        this.$modalReceiptHistory.open()
        break
      case 'version-info':
        this.modalVersionInfo.open()
        break
      case 'screenshot':
        this.screenshot()
        break
      case 'logout':
        this.logout()
        break
    }
  }

  screenshot() {
    this.$webSocket.sendScreenshotMessage()
  }

  openModalUsageStatistics(): void {
    this.modalUsageStatistics.open()
  }
}
